import { useState } from 'react';
import { reduce, map } from 'lodash';
import { Tag, TagType } from 'lib/types/tags';
import { TagRow } from './TagRow';

interface Props {
  tags: Tag[];
  tagTypes: TagType[];
  onRemoveTag: (tagValue: Tag) => void;
  onSelectTag: (tagValue: Tag) => void;
  postId?: number;
}

export const TagsDisplay = ({
  tags, tagTypes, onRemoveTag, onSelectTag, postId,
}: Props) => {
  const tagTypeToTags = reduce(tags, (result, tag) => {
    const newResult = result;
    (newResult[tag.tagTypeId] || (newResult[tag.tagTypeId] = [])).push(tag);
    return newResult;
  }, {} as any);

  const [tagTypeIdThatIsAdding, setTagTypeIdThatIsAdding] = useState<number | null>(null);

  return (
    <div className="mt-4">
      {/* <h6 className="text-lg font-semibold mb-2">Tags and events</h6> */}
      {map(tagTypes, (tt) => (
        <TagRow
          key={tt.id}
          tags={tagTypeToTags[tt.id]}
          tagType={tt}
          onSelect={onSelectTag}
          onRemove={onRemoveTag}
          onAdd={setTagTypeIdThatIsAdding}
          editMode={tagTypeIdThatIsAdding === tt.id}
          postId={postId}
        />
      ))}
    </div>
  );
};
